import React, { useEffect, useState } from 'react';
import { Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { detectPlatform, shiftwave, trackDownload } from '../../utils/downloads';
import './MobileDownloadBar.scss';

const DISMISS_KEY = 'mpx.downloadBarDismissed';

// A sticky "Get ShiftWave" bar for phones that appears once the visitor
// scrolls past the hero, linking straight to their own store.
const MobileDownloadBar: React.FC = () => {
    const platform = detectPlatform();
    const [visible, setVisible] = useState(false);
    const [dismissed, setDismissed] = useState(() => {
        try {
            return sessionStorage.getItem(DISMISS_KEY) === '1';
        } catch {
            return false;
        }
    });

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.8);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const isIOS = platform === 'ios';
    const href = isIOS ? shiftwave.appStoreLink : shiftwave.googlePlayLink;

    if (platform === 'desktop' || dismissed || !href) return null;

    const dismiss = () => {
        setDismissed(true);
        try {
            sessionStorage.setItem(DISMISS_KEY, '1');
        } catch {
            /* storage unavailable */
        }
    };

    return (
        <div className={`mobile-download-bar${visible ? ' mobile-download-bar--visible' : ''}`} aria-hidden={!visible}>
            <img src={shiftwave.icon} alt="" width={40} height={40} />
            <div className="mobile-download-bar__text">
                <strong>ShiftWave</strong>
                <span>Free on {isIOS ? 'the App Store' : 'Google Play'}</span>
            </div>
            <Button
                variant="contained"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                tabIndex={visible ? 0 : -1}
                onClick={() => trackDownload('shiftwave', isIOS ? 'appstore' : 'googleplay', 'mobile_bar')}
            >
                Get
            </Button>
            <IconButton size="small" aria-label="Dismiss" onClick={dismiss} tabIndex={visible ? 0 : -1}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </div>
    );
};

export default MobileDownloadBar;
